import { createBrowserRouter, Navigate } from "react-router-dom";
import AuthPage from "@/pages/admin/AuthPage";
import DashboardPage from "@/pages/admin/DashboardPage";
import NotApplicationPage from "@/pages/admin/NotApplicationPage";
import HomePage from "@/pages/public/HomePage";
import MainLayout from "@/components/layout/MainLayout";
import ProtectedRoute from "@/app/ProtectedRoute";
import AdminLayout from "@/components/layout/AdminLayout";
import { ROUTES } from "@/constants/routes";
import AllApplication from "@/pages/admin/AllApplicationPage";
import RejectApplication from "@/pages/admin/RejectApplicationPage";
import VillageApplicationPage from "@/pages/admin/VillageApplicationPage";

export const router = createBrowserRouter([
  {
    path: ROUTES.root,
    element: <Navigate to={ROUTES.verify} replace />,
  },
  {
    element: <MainLayout />,
    children: [
      {
        path: ROUTES.verify,
        element: <HomePage />,
      },
    ],
  },
  {
    path: ROUTES.adminLogin,
    element: <AuthPage />,
  },
  {
    path: "/admin",
    element: <ProtectedRoute />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={ROUTES.adminDashboard} replace />,
          },
          {
            path: ROUTES.adminDashboard,
            element: <DashboardPage />,
          },
          {
            path: ROUTES.adminNotApplication,
            element: <NotApplicationPage />,
          },
          {
            path: ROUTES.adminAllApplication,
            element: <AllApplication />,
          },
          {
            path: ROUTES.adminRejectApplication,
            element: <RejectApplication />,
          },
          {
            path: ROUTES.adminVillageApplication,
            element: <VillageApplicationPage />,
          },
        ],
      },
    ],
  },
  // {
  //   path: "*",
  //   element: <NotFoundPage />,
  // },
]);
